import { curry, map, mapObjIndexed, pick, pickBy } from 'ramda';
import schemaTypes from './schemaTypes';

export default function makeAllOperators(hierarchy, { withNone }) {
  let records = mapObjIndexed((ops, plug) => {
    return mapObjIndexed((op, name) => {
      return makeOperator(plug, op, name);
    }, ops);
  }, hierarchy);
  if (withNone) records.None = { NoOp: makeOperator('None', { schema: {} }, 'NoOp') };
  return records;
};

function makeOperator(plug, op, name) {
  const fileReferenceKeys = [];
  const referenceKeys = [];
  const nodeReferenceKeys = [];
  const nodeReferenceListKeys = [];
  const plugReferences = {};

  let props = mapObjIndexed((info, key) => {
    const prop = (schemaTypes[info.type]) ? Object.assign({ type: info.type, schema: info }, schemaTypes[info.type](info))
     : { set: (v) => v };

    if (prop.isFileReference) fileReferenceKeys.push(key);
    if (prop.isNodeReference) {
      nodeReferenceKeys.push(key);
      referenceKeys.push(key);
    }

    if (prop.isPlugReference) {
      plugReferences[key] = prop.isPlugReference;
      referenceKeys.push(key);
    }

    if (prop.isReferenceList) nodeReferenceListKeys.push(key);

    return prop;
  }, op.schema);

  const keys = Object.keys(props);

  return {
    keys,
    referenceKeys,
    fileReferenceKeys,
    nodeReferenceKeys,
    nodeReferenceListKeys,
    plugReferences,
    environment: op.environment,

    getProperties() {
      return props;
    },

    typeOf(key) {
      return op.schema[key] && op.schema[key].type;
    },

    set(data, key, val) {
      const newVal = props[key] ? props[key].set(val) : val;
      const isChanged = props[key] && props[key].equals ? !props[key].equals(newVal, data[key]) : newVal !== data[key];
      if (isChanged) data[key] = props[key] && props[key].get ? props[key].get(newVal) : newVal;
      return isChanged;
    },

    /*
    equals(data1, data2) {
      //return (JSON.stringify(data1) === JSON.stringify(data2));
      let isEqual = true;

      for(let key in keys){
        if(data1.hasOwnProperty(key) &&
          ((data1[key].equals && !data1[key].equals(data2)) ||
          (data1[key] !== data2[key]))){
            isEqual = false;
            break;
        }
      }
      return isEqual;
    },
    */

    export(data) {
      // This could be written to remove default keys
      return Object.assign({}, data, {
        name, primitive: plug,
      });
    },

    get(data, key) {
      return props[key] && props[key].get ? props[key].get(data[key]) : data[key];
    },

    init(type, initAttrs={}, name) {
      const result = { type, name: (name || type) };
      for (let key of keys) {
        result[key] = props[key].set(initAttrs[key]); //props.set(result, key, props[key]);
      }
      //result._v = 1;
      return result;
    },

    update(data, primitive, options) {
      let newPrimitive = op.update ?
        op.update.call(op, data, primitive, options) :
        Object.assign(primitive, data);
      const result = newPrimitive || primitive;

      if (!result.nodeId) result.nodeId = options.node.id;
      if (!result.id) result.id = options.node.id;
      result._v = options.node._v;
      return result;
    },
  };
}




// WEBPACK FOOTER //
// ./src/operators/makeAllOperatorsNonImmutable.js